import { Stack, Typography } from '@mui/material';

interface SourceNameCellProps {
  name: string;
  tradeName?: string | null;
}

/** Jméno tipaře, pod ním (je-li vyplněn) obchodní název. */
export const SourceNameCell = ({ name, tradeName }: SourceNameCellProps) => (
  <Stack justifyContent="center" height={1} lineHeight={1.3}>
    <Typography variant="body2">{name}</Typography>
    {tradeName && (
      <Typography variant="caption" color="text.secondary">
        {tradeName}
      </Typography>
    )}
  </Stack>
);
